import React from "react";
    import { TestiMonials } from "./Containt_home";
const Pricing = ()=>{
    return <div>
    <h1>Pricing details page</h1>

  <TestiMonials />;
    </div>
}
export default Pricing;